// src/redux/archerChat/actions.js

import {
  ARCHER_SEND_MESSAGE,
  ARCHER_MESSAGE_SUCCESS,
  ARCHER_MESSAGE_FAILURE,
  ARCHER_TEXT_DELTA,
  ARCHER_SET_CONVERSATION,
  ARCHER_SET_DATA,
  ARCHER_TOOL_ACTIVE,
  ARCHER_NEW_CONVERSATION,
  ARCHER_TOGGLE_WIDGET,
} from './constants';

export const archerSendMessage = (message, conversationId, pageContext) => ({
  type: ARCHER_SEND_MESSAGE,
  payload: { message, conversationId, pageContext },
});

export const archerMessageSuccess = (response) => ({
  type: ARCHER_MESSAGE_SUCCESS,
  payload: response,
});

export const archerMessageFailure = (error) => ({
  type: ARCHER_MESSAGE_FAILURE,
  payload: error,
});

// Fired per text delta — updates the in-progress message in real time
export const archerTextDelta = (accumulatedText) => ({
  type: ARCHER_TEXT_DELTA,
  payload: accumulatedText,
});

// Fired when PHP confirms/creates a conversation ID
export const archerSetConversationId = (conversationId) => ({
  type: ARCHER_SET_CONVERSATION,
  payload: conversationId,
});

// Fired when PHP sends archer.data (table/chart/navigate)
export const archerSetData = (data) => ({
  type: ARCHER_SET_DATA,
  payload: data,
});

// Fired when a tool call starts (shows "Querying..." indicator)
export const archerToolActive = (toolName) => ({
  type: ARCHER_TOOL_ACTIVE,
  payload: toolName,
});

export const archerNewConversation = () => ({
  type: ARCHER_NEW_CONVERSATION,
});

export const archerToggleWidget = () => ({
  type: ARCHER_TOGGLE_WIDGET,
});
